<template>
    <v-container fluid class="pa-5">
        <v-row>
            <HeaderLookbook :header="oldLines"></HeaderLookbook>
        </v-row>

        <v-row v-for="(products, index) in oldLinesProductGrouped" :key="'oldLines' + index" >
            <v-col cols="12" class="pb-0">
                <TemplateLookbook :products="products"></TemplateLookbook>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>

    import HeaderLookbook from "../components/HeaderLookbook";
    import TemplateLookbook from "../components/TemplateLookbook";
    import {oldLines, oldLinesProducts} from "../assets/lookbook2";

    export default {
        name: "Lookbook2",
        components: {TemplateLookbook, HeaderLookbook},

        data: () => ({
            oldLinesProductGrouped: [],
            oldLines: oldLines,
        }),

        created() {
            this.oldLinesProductGrouped = this.listToMatrix(oldLinesProducts,11);
        },

        methods:{
            listToMatrix(list, elementsPerSubArray) {
                var matrix = [], i, k;

                for (i = 0, k = -1; i < list.length; i++) {
                    if (i % elementsPerSubArray === 0) {
                        k++;
                        matrix[k] = [];
                    }

                    matrix[k].push(list[i]);
                }
                return matrix;
            }
        }

    }
</script>

<style scoped>

</style>